import {motion} from 'framer-motion'

import type {PropsWithChildren} from 'react'

export const SlideshowScrim = ({children}: PropsWithChildren) => (
  <motion.div
    initial={'hidden'}
    animate={'visible'}
    exit={'hidden'}
    variants={{visible: {opacity: 1}, hidden: {opacity: 0}}}
    className={'h-dvh w-screen bg-black/90 md:p-spacing-32'}
  >
    {children}
  </motion.div>
)
